// extracted by mini-css-extract-plugin
export default {"adminDashboard":"adminDashboard_adminDashboard__hk6gb"};